module.exports = __webpack_public_path__ + "img/title.6dea9471.png";